<template>
  <div style="width: 100%; height: 100%; display: flex; flex-direction: column">
    <div style="display: flex; flex-direction: column">
      <div
        style="
          display: flex;
          flex-direction: row;
          gap: 15px;
          align-items: center;
          padding: 15px 15px 10px;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 5px;
            gap: 3px;
          "
        >
          <span>{{ userInfo?.websiteName }}</span>
          <!-- <van-icon name="arrow-down" /> -->
        </div>
        <div
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 5px;
            gap: 3px;
          "
          @click="showDatePop = true"
        >
          <span>{{ signDate }}</span>
          <van-icon name="arrow-down" />
        </div>
      </div>
      <van-row justify="center" :gutter="15" style="margin: 0px 10px">
        <van-col span="12">
          <div
            class="sign"
            :class="{ select_tab: siteActive === 'sign' }"
            @click="changeSiteActive('sign')"
          >
            <span>已签到</span>
            <span style="margin-top: 5px"
              >{{ siteInfo?.signInCount ?? 0 }}人</span
            >
          </div>
        </van-col>
        <van-col span="12">
          <div
            class="sign"
            :class="{ select_tab: siteActive === 'unsign' }"
            @click="changeSiteActive('unsign')"
          >
            <span>未签到</span>
            <span style="margin-top: 5px"
              >{{ siteInfo?.unSignInCount ?? 0 }}人</span
            >
          </div>
        </van-col>
      </van-row>
    </div>
    <div v-if="siteActive === 'sign'" style="flex: 1; height: 100%">
      <van-empty
        v-if="signList.length === 0 && !loading"
        description="暂无数据"
      />
      <van-list
        v-model:loading="loading"
        :finished="finish"
        style="height: 100%; overflow: auto"
      >
        <van-cell-group
          inset
          v-for="(item, index) in signList"
          :key="index"
          style="
            --van-cell-group-inset-padding: 10px;
            --van-cell-border-color: #ebedf0;
          "
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              padding: 10px;
              gap: 15px;
              border: 1px solid #ebedf0;
              border-radius: 10px;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                row-gap: 15px;
              "
            >
              <van-row :gutter="10" justify="center">
                <van-col>
                  <van-image
                    width="30"
                    height="30"
                    radius="5"
                    src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
                  />
                </van-col>
                <van-col style="display: flex; align-items: center">
                  <span>{{ item?.empName ?? "" }}</span>
                </van-col>
              </van-row>
              <div
                style="
                  margin-left: auto;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  gap: 10px;
                "
              >
                <span>签{{ item?.signCount ?? 0 }}次</span>
                <van-icon name="arrow" color="#969799" />
              </div>
            </div>
            <div
              v-if="item?.daySignInList"
              v-for="subItem in item.daySignInList"
              :key="subItem.signInId"
              style="display: flex; flex-direction: column; gap: 10px"
            >
              <div
                style="display: flex; flex-direction: column; margin-top: 10px"
              >
                <span>签到时间</span>
                <span>{{ subItem.signTime }}</span>
              </div>

              <div
                style="display: flex; flex-direction: column; margin-top: 10px"
              >
                <span>签到地点</span>
                <span>{{ subItem.signAddress }}</span>
              </div>
            </div>
          </div>
        </van-cell-group>
      </van-list>
    </div>
    <div v-if="siteActive === 'unsign'" style="flex: 1; height: 100%">
      <van-empty v-if="unSignList.length === 0" description="暂无数据" />
      <van-grid v-else :border="false">
        <van-grid-item v-for="(item, index) in unSignList" :key="index">
          <div
            style="
              display: flex;
              width: 100%;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 10px;
              padding: 10px;
            "
          >
            <van-image
              width="60"
              height="60"
              radius="8"
              :src="
                item?.avatar?.length > 0
                  ? item.avatar
                  : 'https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg'
              "
            />
            <span>{{ item.empName }}</span>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
  </div>
  <van-popup v-model:show="showDatePop" position="bottom">
    <van-date-picker v-model="currentDate" title="" @confirm="confirmDate" />
  </van-popup>
</template>

<script setup lang="ts">
import { webSiteList } from "@/api/sign";
import moment from "moment";
import { userAuthStore } from "@/store/auth";

const loading = ref(false);
const finish = ref(false);

const siteActive = ref("sign");
const changeSiteActive = (value) => {
  if (siteActive.value === value) return;
  siteActive.value = value;
};
// 页面数据
const common = userAuthStore();
const siteInfo: any = ref(null);
const unSignList: any = ref([]);
const signList: any = ref([]);
const userInfo = ref(common.currUserData);

// 时间选择
const signDate = ref(moment().format("YYYY-MM-DD"));
const showDatePop = ref(false);
const currentDate = ref([
  moment().year().toString(),
  (moment().month() + 1).toString(),
  moment().date().toString(),
]);
// 确认选择时间
const confirmDate = () => {
  const [year, month, day] = currentDate.value;
  signDate.value = `${year}-${month}-${day}`;
  showDatePop.value = false;
  requestData();
};

const requestData = () => {
  loading.value = true;
  finish.value = false;
  // 获取网点统计
  webSiteList({ signDate: moment(signDate.value).format("YYYYMMDD") })
    .then((res: any) => {
      console.log("list", res);
      loading.value = false;
      finish.value = true;
      if (res) {
        siteInfo.value = res;
        unSignList.value = res?.unSignInList ?? [];
        signList.value = res?.signInList ?? [];
      }
    })
    .catch(() => {
      loading.value = false;
      finish.value = true;
    });
};
onMounted(() => {
  requestData();
});
</script>

<style scoped>
.sign {
  flex: 1;
  width: 100%;
  height: 80px;
  border-radius: 10px;
  background-color: #f2f3f5;
  /* box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1); */
  display: flex;
  flex-direction: column;
  column-gap: 5px;
  padding: 0 15px;
  justify-content: center;
  color: #646566;
  box-sizing: border-box;
}

.select_tab {
  position: relative;
  background-color: #1989fa;
  color: #fff;
}

.select_tab::after {
  content: "";
  position: absolute;
  bottom: -10px; /* 调整三角形位置 */
  left: calc(50% - 10px); /* 使其位于底部中心 */
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid #1989fa; /* 三角形颜色和背景色一致 */
}
</style>
